const styles = {
  cancelButton: {
    marginLeft: "20px",
    marginTop: "30px",
  },
  interviewBy: {
    maxWidth: "80%",
    display: "flex",
    alignItems: "center",
    flex: 1,
    marginBottom: 16,
  },
  readOnlyInterviewBy: {
    maxWidth: "80%",
    border: "solid 1px",
    borderRadius: "4px",
    padding: "8px",
    borderColor: "rgba(0, 0, 0, 0.3",
    backgroundColor: "rgba(239, 239, 239, 1.5)",
    paddingRight: "20px",
  },
  greyTableCell: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
  },
};

export default styles;

export const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  mini: {
    maxWidth: "5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  normal: {
    maxWidth: "15rem",
  },
  large: {
    maxWidth: "18rem",
  },
};
